import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import ApplicantPortal from "@/pages/ApplicantPortal";
import RefereeUpload from "@/pages/RefereeUpload";
import Login from "@/pages/Login";
import DashboardLayout from "@/pages/DashboardLayout";
import DashboardHome from "@/pages/DashboardHome";
import Applications from "@/pages/Applications";
import ApplicationDetail from "@/pages/ApplicationDetail";
import EvaluatorsAdmin from "@/pages/EvaluatorsAdmin";
import AiAdmin from "@/pages/AiAdmin";
import Results from "@/pages/Results";
import EvaluatorLayout from "@/pages/EvaluatorLayout";
import EvaluatorHome from "@/pages/EvaluatorHome";
import EvaluatorReview from "@/pages/EvaluatorReview";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        {/* PUBLIC_URL (set at build time) lets the app live under a path, e.g. /some-path */}
        <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/apply" element={<ApplicantPortal />} />
            <Route path="/success" element={<Navigate to="/apply" replace />} />
            <Route path="/recommend/:token" element={<RefereeUpload />} />
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin">
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="applications" element={<Applications />} />
              <Route path="applications/:id" element={<ApplicationDetail />} />
              <Route path="results" element={<Results />} />
              <Route path="evaluators" element={<EvaluatorsAdmin />} />
              <Route path="ai" element={<AiAdmin />} />
            </Route>
            <Route
              path="/evaluator"
              element={
                <ProtectedRoute role="evaluator">
                  <EvaluatorLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<EvaluatorHome />} />
              <Route path="applications/:id" element={<EvaluatorReview />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
